"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PcbDrawingWithLayersSchema = void 0;
const DrawingWithLayers_1 = require("./DrawingWithLayers");
const PcbDrawing_1 = require("./PcbDrawing");
exports.PcbDrawingWithLayersSchema = (0, DrawingWithLayers_1.DrawingWithLayersSchemaT)(PcbDrawing_1.PcbDrawingSchema);
//# sourceMappingURL=PcbDrawingWithLayers.js.map